import * as dataStore from './DataStore';
import { getTitleUi } from './TitleInfoSelector';
import EResource from '../models/EResource';

/**
 * @returns an EResource object
 */
export function getEResources() {
	const eResources = dataStore.getJsonData().FeatureContent.EResourceRecommendation;
	const sourceId = getTitleUi(dataStore.getJsonData());

	let resources = [];

	if (eResources) {
		const data = eResources.db_resources;
		if (data != null && data.length > 0) {
			resources = data.map((eResource) => {
				eResource.url = getResourceItemUrlFromLinks(eResource.links);
				return new EResource(eResource, sourceId);
			});
		}
	}

	return resources;
}

/**
 * Validates the links array attached to the eResource Item JSON
 *
 * NOTE: For each eResource item we receive an array, but it appears that this array
 * always contains just 1 single item, which is why we check against the first element.
 *
 * @param {Object[]} links The links associated with the eResource Item
 * @returns The associated URL for the eResource item if it exits, otherwise returns an empty string.
 */
function getResourceItemUrlFromLinks(links){
	let url = '';
	if (!links) { return url;}

	if (links.length > 0 && !links[0].hasOwnProperty('url')){
		return url;
	}

	url = links[0].url;
	return url;
}



// WEBPACK FOOTER //
// ./src/data/EResourcesSelector.js